/**
 * Web配置相关的localStorage工具类
 */

/**
 * 获取当前商户域名（9988 端口为测试环境，固定使用测试服务器域名）
 * @returns {string} 域名
 */
export function getDomain() {
  return window.location.port === '9988' ? '47.111.114.153' : window.location.hostname;
}

/**
 * 从localStorage中读取配置
 * @param {string} hostname - 域名
 * @returns {Object|null} 配置对象或null
 */
export function getConfigFromLocalStorage(hostname) {
  try {
    const configStr = localStorage.getItem(hostname);
    return configStr ? JSON.parse(configStr) : null;
  } catch (error) {
    console.error('读取localStorage配置失败:', error);
    return null;
  }
}

/**
 * 保存配置到localStorage
 * @param {string} hostname - 域名
 * @param {Object} config - 配置对象
 */
export function saveConfigToLocalStorage(hostname, config) {
  try {
    localStorage.setItem(hostname, JSON.stringify(config));
  } catch (error) {
    console.error('保存localStorage配置失败:', error);
  }
}

/**
 * 设置页面标题
 * @param {string} merchantName - 商户名称
 */
export function setPageTitle() {
  document.title = "有界AI设计";
} 

/**
 * 设置favicon
 * @param {string} url - favicon URL
 */
export function setFavicon(url) {
  if (!url) return;
  // 移除所有现有的favicon
  const oldLinks = document.querySelectorAll("link[rel*='icon']");
  oldLinks.forEach((link) => document.head.removeChild(link));

  // 创建新的favicon
  const link = document.createElement("link");
  link.rel = "icon";
  link.type = "image/png"; // 或 'image/x-icon'
  link.href = url;

  // 添加到head
  document.head.appendChild(link);
}